type PageInfo = {
	contentId: string; // for tracking page load
	seoTitle: string;
};

export enum ClubVolkswagenPages {
	AcceptancePage,
	AddVehiclePage,
	AddVehiclePendingPage,
	Dashboard,
	LoginPage,
	NoVehiclesPage,
	PendingPage,
	SalesforceVoucherPage,
	SignUpPage,
	UnexpectedErrorPage,
}

export const ClubVolkswagenPagesInfo: Record<ClubVolkswagenPages, PageInfo> = {
	[ClubVolkswagenPages.AcceptancePage]: {
		contentId: 'Club Volkswagen - AcceptancePage',
		seoTitle: 'Estás a un solo paso... | Club Volkswagen | Volkswagen España',
	},
	[ClubVolkswagenPages.AddVehiclePage]: {
		contentId: 'Club Volkswagen - AddVehiclePage',
		seoTitle: 'Añade tu Volkswagen | Club Volkswagen | Volkswagen España',
	},
	[ClubVolkswagenPages.AddVehiclePendingPage]: {
		contentId: 'Club Volkswagen - AddVehiclePendingPage',
		seoTitle: '¡Casi, casi! | Club Volkswagen | Volkswagen España',
	},
	[ClubVolkswagenPages.Dashboard]: {
		contentId: 'Club Volkswagen - DashboardPage',
		seoTitle: 'Qué alegría verte, {name} | Club Volkswagen | Volkswagen España',
	},
	[ClubVolkswagenPages.LoginPage]: {
		contentId: 'Club Volkswagen - LoginPage',
		seoTitle: 'Mi Club Volkswagen. ¡Accede ahora! | Club Volkswagen | Volkswagen España',
	},
	[ClubVolkswagenPages.NoVehiclesPage]: {
		contentId: 'Club Volkswagen - NoVehiclesPage',
		seoTitle: 'Añade tu Volkswagen | Club Volkswagen | Volkswagen España',
	},
	[ClubVolkswagenPages.PendingPage]: {
		contentId: 'Club Volkswagen - PendingPage',
		seoTitle: '¡{name}, ya tienes un pie dentro! ',
	},
	[ClubVolkswagenPages.SalesforceVoucherPage]: {
		contentId: 'Club Volkswagen - SalesforceVoucherPage - Campaign: {campaignId}',
		seoTitle: '{voucherTitle} | Club Volkswagen | Volkswagen España',
	},
	[ClubVolkswagenPages.SignUpPage]: {
		contentId: 'Club Volkswagen - SignUpPage',
		seoTitle: 'Únete al Club | Club Volkswagen | Volkswagen España',
	},
	[ClubVolkswagenPages.UnexpectedErrorPage]: {
		contentId: 'Club Volkswagen - UnexpectedErrorPage',
		seoTitle: 'Error | Club Volkswagen | Volkswagen España',
	},
};

type PageInfoParamsByPage = {
	[ClubVolkswagenPages.Dashboard]: { name: string };
	[ClubVolkswagenPages.PendingPage]: { name: string };
	[ClubVolkswagenPages.SalesforceVoucherPage]: {
		campaignId: string;
		voucherTitle: string;
	};
};

type StaticClubVolkswagenPage = Exclude<ClubVolkswagenPages, keyof PageInfoParamsByPage>;
type PageInfoParams = Record<string, string>;

const interpolate = (template: string, params: PageInfoParams, encodeValues = false): string =>
	template.replace(/\{(\w+)\}/g, (placeholder, key: string) => {
		const value = params[key];
		return value === undefined ? placeholder : encodeValues ? encodeURIComponent(value) : value;
	});

export function getClubVolkswagenPageInfo<TPage extends keyof PageInfoParamsByPage>(
	page: TPage,
	params: PageInfoParamsByPage[TPage],
): PageInfo;
export function getClubVolkswagenPageInfo(page: StaticClubVolkswagenPage): PageInfo;
export function getClubVolkswagenPageInfo(page: ClubVolkswagenPages, params: PageInfoParams = {}): PageInfo {
	const info = ClubVolkswagenPagesInfo[page];

	return {
		contentId: interpolate(info.contentId, params),
		seoTitle: interpolate(info.seoTitle, params),
	};
}
